// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"336":"d7b5b9cb","623":"466471a0","657":"4a7ed476"}[chunkId] + ".chunk.js";
};